import * as React from 'react'
import { format } from 'd3-format'
import * as baseStyles from './field.component.styl'

export interface Props {
  label: string
  value: string | number
  customStyles?: { [className: string]: string }
  role?: string
}

const Field: React.FC<Props> = (props: Props) => {
  const { label, value, customStyles } = props
  let styles = baseStyles
  if (typeof customStyles !== 'undefined') styles = customStyles
  let formattedValue = value
  if (typeof value === 'number') {
    // format number as a string with a ',' thousands separator
    formattedValue = format(',')(value)
  }
  return (
    <div className={styles.fieldWrapper} role={props.role}>
      <div className={styles.fieldLabel} role="field-label">
        {label}
      </div>
      <div className={styles.fieldValue} role="field-value">
        {formattedValue}
      </div>
    </div>
  )
}

export default Field
